module.exports = __webpack_public_path__ + "static/media/icon-no-coins.013285ee.png";